export default "__VITE_ASSET__48645b3f__"